module.exports = __webpack_public_path__ + "static/mapa-stacji-1e7ae89d570251714571f04699473499.svg";